import { render, staticRenderFns } from "./learningModel.vue?vue&type=template&id=c4dbec54&scoped=true&"
import script from "./learningModel.vue?vue&type=script&lang=js&"
export * from "./learningModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dbec54",
  null
  
)

export default component.exports